import React, { useEffect, useState } from "react";
import SearchableDropdown from "../common/SearchableDropdown";
import { notifyError } from "../helper/Toaster";
import { createExcel, exportStudentDetails } from "../../requests";
import { formatDateLong, formatGrade } from "../helper/formatters";
import { useDispatch } from "react-redux";
import { startLoader } from "../../_store/reducers/loaderReducer";
import { stopLoader } from "../../_store/reducers/loaderReducer";

const ExportStudent = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);


  const dispatch = useDispatch();
  const [grade, setGrade] = useState("");
  const [data, setData] = useState([]);	


  const fetch_data = async (pageVal) => {
    dispatch(startLoader());
    try {
      const res = await exportStudentDetails({page: pageVal, limit: limit, grade: grade});
      setData(res.data.data);
      setTotalCount(res.data.totalCount);
     
    } catch (error) {
      console.log(error);
      
      notifyError(error?.response?.data?.error || "Error fetching data");
    } finally {
      dispatch(stopLoader());
    }
  };

  

  const exportData = async (grade_, student_name_) => { 
    dispatch(startLoader());
    try {
      const response = await createExcel({ grade: grade_, student_name: student_name_ });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${grade_ || "all"}-${student_name_ || "all"}.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
      notifyError(error.response?.data?.error || "Error exporting data");
    } finally {
      dispatch(stopLoader());
    }
  };

  useEffect(() => {
    setPage(1);
    fetch_data(1);
  }, [grade]);

  useEffect(() => {
    fetch_data(page);
  }, [page,limit]);

  const subjects = [
    "All subjects",
    "Mathematics",
    "English",
    "Science",
    "History",
    "Geography",
    "Physics",
    "Chemistry",
    "Biology",
    "Computer Science",
    "Information Technology",
    "Environmental Science",
    "Political Science",
    "Economics",
    "Business Studies",
    "Accountancy",
    "Sociology",
    "Psychology",
    "Philosophy",
    "Civics",
    "Literature",
    "Grammar",
    "Statistics",
    "Engineering Drawing (Theory)",
    "Design and Technology (Theory)",
    "Astronomy",
    "Geology",
    "Anthropology",
    "Archaeology",
    "Law",
    "Media Studies",
    "Communication Skills (Theory)",
    "Entrepreneurship",
    "Marketing",
    "Tourism and Hospitality (Theory)",
    "Fashion Studies (Theory)",
    "Agriculture (Theory)",
    "Computer Applications",
    "Applied Mathematics",
    "Modern History",
    "World History",
    "Ancient History",
    "Political Theory",
    "International Relations",
    "Public Administration",
    "Linguistics",
    "Environmental Studies",
    "Current Affairs",
    "General Knowledge",
    "Moral Science",
  ];

  const classes = ["All classes",1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <div className="overview-head">
        <div className="overview-head-left">Export Student Details</div>
        <div className="overview-head-right">
          <SearchableDropdown
            options={[...classes]}
            selected={grade}
            setSelected={(e) => setGrade(e)}
            color="#E5E7EB"
            allowManualEntry={false}
          />

        
          <button className="my-btn" onClick={() => exportData(grade)}>Export</button>
        </div>
      </div>
      <div className="teacher-table" style={{ borderTop: "none" }}>
        <div className="teacher-table-head">
          <div className="teacher-table-head-cell" style={{ width: "22%" }}>
            Student Name
          </div>

          <div className="teacher-table-head-cell" style={{ width: "22%" }}>
            Grade
          </div>
          <div className="teacher-table-head-cell" style={{ width: "22%" }}>
            Roll No
          </div>
          <div className="teacher-table-head-cell" style={{ width: "22%" }}>
            last uploaded on
          </div>

          <div className="teacher-table-head-cell" style={{ width: "12%" }}>
            Export
          </div>
        </div>

        {data.length > 0 &&
          data.map((el, i) => (
            <div
              key={i}
              className="teacher-table-row"
              style={{ borderBottom: i == data.length - 1 && "none" }}
            >
              <div className="teacher-table-row-cell" style={{ width: "22%" }}>
                {el.student_name}
              </div>

              <div className="teacher-table-row-cell" style={{ width: "22%" }}>
                {el.grade}
              </div>
              <div className="teacher-table-row-cell" style={{ width: "22%" }}>
                {" "}
                <span>{el.student_rollno}</span>
              </div>
              <div className="teacher-table-row-cell" style={{ width: "22%" }}>
                {formatDateLong(el.last_uploaded)}
              </div>

              <div className="teacher-table-row-cell" style={{ width: "12%"}} onClick={() => exportData(el.grade, el.student_name)} >
                <button className="ai-fd-fb-btn">Export</button>
              </div>
            </div>
          ))}
      </div>
      <div className="di-flex" style = {{width: '100%'}}>
          <div style={{ color: "#6B7280" }}>
            {" "}
            Showing {((page-1) * limit )+ 1} to {data.length + (page - 1) * limit} out of {totalCount}{" "}
            items{" "}
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page == 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page == 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={data.length + (page - 1) * limit >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  data.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (data.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>
    </div>
  );
};

export default ExportStudent;
